<h3 style="margin-bottom: 0;">Slicks</h3>
<div class="sidebar-content">
    <div class="">
        <div class="card shadow-none">
            <div class="flex flex-column mb-2">
                <label class="w-full ss-g-globalClassLabel">
                    Título do Slick
                    <div class="p-inputgroup mt-2">
                        <input type="text" id="title" pInputText class="w-full" (ngModelChange)="onInputChange.emit()"
                            [(ngModel)]="slickTitle" [ngClass]="{'ng-invalid': hasError1, 'ng-dirty': hasError1}">
                    </div>
                </label>
                <div class="flex align-items-center justify-content-between">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="hasError1" class="p-error">
                        Obrigatório
                    </small>

                </div>
            </div>
            <div class="flex flex-column mb-2">
                <label class="w-full ss-g-globalClassLabel">
                    Descrição
                </label>
                <div class="mb-2">
                    <textarea rows="3" cols="30" class="w-full p-inputtextarea p-inputtext p-component p-element"
                        placeholder="Descrição do Slick" [(ngModel)]="slickDesc" pInputTextarea></textarea>
                </div>

            </div>
            <div class="flex flex-column mb-2">
                <label class="w-full ss-g-globalClassLabel">Tipo de Slick
                    <p-dropdown [options]="slickTypes" [(ngModel)]="selectedSlickType" (onChange)="onTypeChange.emit($event)"
                        [ngClass]="{'ng-invalid': hasError2, 'ng-dirty': hasError2}" id="slickTypeDropdown"
                        placeholder="Selecione um tipo" optionLabel="label" class="w-full ss-g-sidebarVendas mt-2">
                    </p-dropdown>
                </label>
                <div class="flex align-items-center justify-content-between">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="hasError2" class="p-error">
                        Obrigatório
                    </small>

                </div>
            </div>
            <div class="p-fluid">
                <!-- <div class="">
                        <label class="w-full ss-g-globalClassLabel">Modo de visualização
                            <div class="mt-2">
                                <p-selectButton class=" mt-5" [options]="landscapeOptions"
                                    (onChange)="changeLandscape()" [(ngModel)]="valSelect1Video" optionLabel="name">
                                    <ng-template let-option pTemplate="item">
                                        <div class="flex align-items-center justify-content-center w-full">
                                            <i [ngClass]="option.icon" class="mr-2"></i>
                                            <span class="font-bold">{{ option.name }}</span>
                                        </div>
                                    </ng-template>
                                </p-selectButton>
                            </div>
                        </label>
                    </div> -->
            </div>

            <!-- <div class="col-12 mt-3 mb-2 flex flex-column" style="padding: 0;" *ngIf="typeLive"> -->
            <div class="mt-3 mb-2 flex flex-column" *ngIf="typeLive">
                <p-fileUpload #fileUpload name="demo[]" accept="video/*" [multiple]="false" *ngIf="!videoPreviewUrl"
                    [ngClass]="{'ng-invalid': hasError3, 'ng-dirty': hasError3, 'file-upload-error': hasError3}"
                    (onSelect)="onFileSelect.emit($event)" [customUpload]="true" [showCancelButton]="false"
                    (uploadHandler)="myUploadMethod.emit($event)"
                    styleClass="border-1 surface-border surface-card border-round">
                    <ng-template pTemplate="content">
                        <div [ngClass]="{'video-upload-container': valSelect1Video.value === 1, 'video-upload-container-landscape': valSelect1Video.value === 2}"
                            (click)="fileUpload.choose()">
                            <div class="content">
                                <!-- Exibir apenas se nenhum arquivo for selecionado -->
                                <div *ngIf="!invoiceSelected"
                                    class="flex flex-column justify-content-center align-items-center">
                                    <i class="pi pi-file text-4xl text-primary"></i>
                                    <span class="block font-semibold text-900 text-lg mt-3">Arraste um arquivo ou
                                        selecione</span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-fileUpload>

                <div *ngIf="videoPreviewUrl"
                    [ngClass]="{'video-upload-container': valSelect1Video.value === 1, 'video-upload-container-landscape': valSelect1Video.value === 2}">
                    <div
                        [ngClass]="{'ss-l-video-container-inner': valSelect1Video.value === 1, 'ss-g-video-container-inner-landscape': valSelect1Video.value === 2}">

                        <video #videoPlayer [ src ]="videoPreviewUrl" controls [controls]="true" muted
                            [muted]="true" autoplay [autoplay]="true" loop [loop]="true"
                            (mouseenter)="startVideo.emit(videoPlayer)" (mouseleave)="resetVideo.emit(videoPlayer)"
                            [ngClass]="{'video-preview': valSelect1Video.value === 1, 'video-preview-landscape': valSelect1Video.value === 2}"
                            (ended)="videoPlayer.play()" (canplaythrough)="handleCanPlayThrough.emit()" playsinline
                            webkit-playsinline></video>

                        <!-- Botão de fechar -->
                        <button *ngIf="videoPreviewUrl" pButton pRipple type="button" icon="pi pi-times"
                            class="p-button-rounded p-button-primary text-sm absolute justify-content-center align-items-center cursor-pointer w-2rem h-2rem"
                            style="top: -10px; right: -10px; cursor: pointer;" (click)="removeVideo.emit($event)"></button>
                    </div>
                </div>

                <div class="mt-2" *ngIf="uploadProgressVideo > 0" style="position: relative;">
                    <p-progressBar [value]="uploadProgressVideo" class="w-full"></p-progressBar>
                    <!-- <div class="progress-value"
                            style="position: absolute; width: 100%; top: 0; text-align: center; color: #FFFFFF;">
                            {{ uploadProgressVideo.toFixed(0) }}%
                        </div> -->
                </div>

                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="hasError3" class="p-error">
                        Obrigatório
                    </small>

                </div>
                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="hasSizeVideoError" class="p-error">
                        O vídeo deve ter no máximo 400 MB.
                    </small>
                </div>
                <div class="flex align-items-center justify-content-between mt-2">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="hasTypeVideoError" class="p-error">
                        ipos de vídeo permitidos: mp4, mov, mp3, wav, webm, avi, wmv, mkv, flv, mpeg, mpg, 3gp, m4v.
                    </small>
                </div>
            </div>

            <div class="col-12 mt-3 mb-2 flex flex-column" style="padding: 0;">
                <p-fileUpload #imageUpload name="image[]" accept="image/*" [multiple]="false" *ngIf="!imageSelected"
                    (onSelect)="onImageSelect.emit($event)" [customUpload]="true" [showCancelButton]="false"
                    (uploadHandler)="myImageUploadMethod.emit($event)"
                    styleClass="border-1 surface-border surface-card border-round">
                    <ng-template pTemplate="content">
                        <div [ngClass]="{'custom-upload-area': valSelect1Video.value === 1, 'custom-upload-area-landscape': valSelect1Video.value === 2}"
                            (click)="imageUpload.choose()">
                            <!-- Exibir apenas se nenhum arquivo de imagem for selecionado image-preview -->
                            <div *ngIf="!imageSelected"
                                class="flex flex-column justify-content-center align-items-center">
                                <i class="pi pi-file text-4xl text-primary"></i>
                                <span class="block font-semibold text-900 text-center text-lg mt-3">Arraste uma
                                    imagem ou
                                    selecione</span>
                            </div>


                        </div>
                    </ng-template>
                </p-fileUpload>
                <!-- Exibir após selecionar um arquivo de imagem -->
                <div *ngIf="imageSelected" class="flex flex-wrap gap-3 border-round"
                    [ngClass]="{'video-upload-container': valSelect1Video.value === 1, 'video-upload-container-landscape': valSelect1Video.value === 2}">
                    <div class="border-3 border-transparent border-round position-relative"
                        (mouseenter)="showImageDeleteButton = true"
                        [ngClass]="{'ss-l-video-container-inner': valSelect1Video.value === 1, 'ss-g-video-container-inner-landscape': valSelect1Video.value === 2}"
                        (mouseleave)="showImageDeleteButton = false">
                        <img [src]="imagePreviewUrl"
                            [ngClass]="{'video-preview': valSelect1Video.value === 1, 'video-preview-landscape': valSelect1Video.value === 2}"
                            class="image-preview shadow-2 border-round">
                        <!-- Botão de excluir para imagem -->
                        <button *ngIf="showImageDeleteButton" pButton pRipple type="button" icon="pi pi-times"
                            class="p-button-rounded p-button-primary text-sm absolute justify-content-center align-items-center cursor-pointer w-2rem h-2rem"
                            style="top: -10px; right: -10px;" (click)="removeImage.emit($event)"></button>
                    </div>
                </div>
                <div class="flex align-items-center justify-content-between mt-2" *ngIf="uploadProgress > 0">
                    <p-progressBar [value]="uploadProgress" class="w-full"></p-progressBar>
                    <!-- <div class="progress-value"
                            style="position: absolute; width: 100%; top: 0; text-align: center; color: #FFFFFF;">
                            {{ uploadProgress.toFixed(0) }}%
                        </div> -->
                </div>
                <div class="flex align-items-center justify-content-between">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="erroTamanhoImagem" class="p-error">
                        Tamanho da imagem deve ser de no máximo 1 mega
                    </small>
                </div>
                <div class="flex align-items-center justify-content-between">
                    <!-- Mensagem de Erro à esquerda -->
                    <small *ngIf="erroTipoImagem" class="p-error">
                        Tipo da imagem deve ser .png, .webp, .jpg ou jpeg
                    </small>
                </div>
            </div>



            <div class="flex flex-column mb-4 mt-5 w-full">
                <label class="w-full ss-g-globalClassLabel">Tags</label>
                <p-chips [(ngModel)]="selectedTags" class="w-full" (ngModelChange)="updateTagsString.emit()" separator=","
                    placeholder="Insira uma tag e aperte ',' ou ⏎" styleClass="w-full"></p-chips>

            </div>
            <!-- Contêiner principal para alinhar tudo verticalmente -->
            <div class="flex flex-column">
                <!-- Primeira label sozinha -->
                <div class="align-items-center mb-2">
                    <label>mais opções</label>
                </div>

                <!-- Segundo contêiner para os switches e labels -->
                <div class="flex align-items-center mb-2">

                    <!-- <p-inputSwitch [(ngModel)]="publicarAgora" class="mr-2" (onChange)="simular.emit()"></p-inputSwitch> -->
                    <label>Publicar Agora</label>
                </div>

            </div>


            <div class="flex align-items-center mt-5 mb-2 w-full" *ngIf="!publicarAgora">
                <label class="ss-g-globalClassLabel">Data e hora</label>
            </div>
            <div class="flex align-items-center w-full" *ngIf="!publicarAgora">
                <p-calendar [(ngModel)]="dataSelecionada" (ngModelChange)="onDateChange.emit($event)" [showTime]="true"
                    class="mb-2 calendar-grid " [showIcon]="true" [disabledDates]="disabledDates" [readonlyInput]="true"
                    [minDate]="minDate"
                    [ngClass]="{'ng-invalid': hasErrorCalendar, 'ng-dirty': hasErrorCalendar}"></p-calendar>

            </div>
            <div class="flex align-items-center justify-content-between">
                <small *ngIf="hasErrorCalendar" class="p-error">
                    Obrigatório
                </small>
            </div>
        </div>
    </div>
</div>
<div style="text-align: right;">
    <button pButton pRipple label="Fechar" (click)="onClose.emit()" class="p-button-outlined "></button>
    <button pButton pRipple label="Upload" [loading]="loadingBtn" (click)="onSave.emit()" [disabled]="uploadOn"
        class="ml-2 mr-2"></button>

</div>